import { api } from "../../common/config/api";

export const BANNER_URL = {
   getBanners: `${api.withAPI}/v1/banner`,
   createBanner: `${api.withAPI}/v1/banner`,
   editBanner: `${api.withAPI}/v1/banner`,
   removeBanner: `${api.withAPI}/v1/banner`
}
